import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import React from "react";

export const ErrorDialog: React.FC<{ error: string | null, onClose: () => void }> = ({ error, onClose }) => {
  return (
    <Dialog open={error !== null}>
      <DialogTitle>Something went wrong</DialogTitle>
      <DialogContent>
        <Typography variant="body1">{error}</Typography>
      </DialogContent>
      <DialogActions>
        <Button data-test="close-error-dialog" onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}